import React from 'react';
import MenuList from '../components/MenuList';
import { Link } from 'react-router-dom';
import { MenuItem } from '../static/menu';

interface SidebarProps {
	menu: ReadonlyArray<MenuItem>;
	isOpen: boolean;
	onClose: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ menu, isOpen, onClose }) => {
	React.useEffect(() => {
		const onKeyDown = (event: KeyboardEvent) => {
			if (isOpen && event.key === 'Escape') {
				onClose();
			}
		};

		document.addEventListener('keydown', onKeyDown);
		return () => document.removeEventListener('keydown', onKeyDown);
	}, [isOpen, onClose]);

	return (
		<>
			{isOpen && (
				<div className="sidebar-backdrop" onClick={onClose} />
			)}
			<aside className={'left-sidebar' + (isOpen ? ' open' : '')}>
				<button
					type="button"
					className="sidebar-close"
					aria-label="Chiudi menu"
					onClick={onClose}
				>
					<i className="mdi mdi-close" />
				</button>
				<div className="scroll-sidebar">
					<div className="user-profile">
						<Link to="/" onClick={onClose}>
							<img
								src={process.env.PUBLIC_URL + '/logo_gruppo.svg'}
								alt="logo"
								id="logo"
							/>
						</Link>
					</div>
					<MenuList voices={menu} onNavigate={onClose} />
				</div>
			</aside>
		</>
	);
};
